import React, { useEffect, useState } from "react";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormHelperText,
} from "@mui/material";
import TickCircle from "../../Components/assets/Images/tick-circle.svg";
import EmptyCircle from "../../Components/assets/Images/TickEmptyCircle.svg";
import styles from "./Selectdropdown.module.scss";

interface Props {
  LabelName: string;
  menuItems: any;
  name: any;
  value: any;
  handleChange: any;
  error: any;
  helperText: any;
  setOthers?: any;
  disabled?: any;
  onBlur?: any;
}

const CommonRadioGroup: React.FC<Props> = ({
  LabelName,
  menuItems,
  name,
  value,
  handleChange,
  error,
  helperText,
  setOthers,
  disabled,
  onBlur,
}) => {
  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  const [mode, setMode] = useState(getSystemTheme());

  useEffect(() => {
    setMode(getSystemTheme());
  }, [getSystemTheme]);
  return (
    <FormControl error={error}>
      <RadioGroup
        name={name}
        value={value?.value || ""}
        onChange={(e) => {
          const selected = menuItems.find(
            (item: any) => item.value === e.target.value,
          );

          if (setOthers) {
            setOthers(selected);
          }

          handleChange({
            target: {
              name,
              value: selected,
            },
          });
        }}
        onBlur={onBlur}
        sx={{
          // marginLeft: "25px",
          marginLeft: "0px",
          // border: "1px solid #E7EAEE",
          borderRadius: "8px",
          // width: "max-content",
          overflow: "hidden",
        }}
        className={styles.radioSection}
      >
        {menuItems.map((a: any, index: number) => (
          <FormControlLabel
            key={index}
            value={a.value}
            disabled={disabled}
            sx={{
           
              // borderRight: "1px solid #E7EAEE",
              // background: a.value === value?.value ? "#FAFAFA" : "",
              // width: "98px !important",
              "&:last-child": {
                borderRight: "0px",
              },
            }}
            className={styles.radiowrap}
            control={
              <Radio
                icon={
                  <img
                    src={EmptyCircle}
                    alt="unselected"
                    // style={{
                    //   filter:
                    //     mode === "dark"
                    //       ? "grayscale(0.9) invert(0.9) brightness(1)"
                    //       : "",
                    // }}
                  />
                }
                checkedIcon={<img src={TickCircle} alt="selected" />}
                disableFocusRipple
                disableTouchRipple
                disableRipple
                sx={{
                  width: "20px",
                  height: "20px",
                }}
              />
            }
            label={
              <div
                className={styles.radioLabel}
                style={{
                  color:
                    a.value === value?.value
                      ? "var(--ds-text-primary)"
                      : "var(--ds-text-territory)",
                  fontWeight: a.value === value?.value ? "500" : "400",
                }}
              >
                {a.value}
              </div>
            }
          />
        ))}
      </RadioGroup>

      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default CommonRadioGroup;
